var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('r-bread-crumbs',{staticClass:"mb-2",attrs:{"items":_vm.$route.meta.breadcrumbs || []}}),_c('div',{staticClass:"toolbar-directories"},[_c('h2',{staticClass:"nomira camembert"},[_vm._v(" "+_vm._s(_vm.$route.meta.title)+" ")]),_c('user-info')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }